import React from 'react';
import { Checkbox, FormGroup } from 'react-bootstrap';
import { updateWorkflowIncludedChange } from '../../submissions/actions'

export default class IncludedCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            included: !!this.props.submission.included ? this.props.submission.included : [],
            submission : this.props.submission
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        let value = this.state.included
        let updatedSubmission = this.state.submission;
        const pos = value.indexOf(evt.target.name);
        const args = pos < 0 ? [value.length, 1, evt.target.name] : [pos, 1];
        value.splice(...args);
        updatedSubmission.included = value;
        this.setState({
            included : value,
            submission : updatedSubmission
        })
        this.props.handleIncludedoption(this.state.included)
        updateWorkflowIncludedChange(this.state.included)
    }

    componentDidMount() {
        const { included } = this.state;
        let updatedSubmission = this.state.submission;
        let value = this.state.included;
        if (this.props.isPCOpsChecked == true && included.includes('extendedCompletedOps') == true) {
            const pos = value.indexOf('extendedCompletedOps');
            value.splice(pos,1);
            this.setState({
                included : value,
                submission : updatedSubmission
            })
            this.props.handleIncludedoption(this.state.included)
            updateWorkflowIncludedChange(this.state.included)
        }
    }

    render() {
        const { value } = this.props;
        const { included } = this.state;
        return (
            <FormGroup >
                {this.props.options.map((option, idx) => {
                    return (
                        <Checkbox
                            key={`checkbox-group-input-${idx}`}
                            value={value.find(val => val === option.value)}
                            name={option.value}
                            onChange={this.handleChange}
                            checked={included.includes(option.value)}
                            disabled={!value.includes(option.value)}
                        >
                        </Checkbox>
                    );
                })}
            </FormGroup>
        );
    }
}
